import React, { useState } from "react";
import Select from "./Select";
import "./StatusAction.css";

/** A status badge stays readable while its adjacent button owns the action. */
export default function StatusAction({ value, label, badgeClassName = "", options, onChange }: {
  value: string; label: string; badgeClassName?: string;
  options: readonly { value: string; label: string }[];
  onChange: (value: string) => Promise<void>;
}) {
  const [busy, setBusy] = useState(false);
  return <div className="navo-status-action" aria-busy={busy}>
    <span className={`status-badge ${badgeClassName}`}>{label}</span>
    <Select aria-label={`Change status: ${label}`} value={value} disabled={busy} onChange={async event => {
      setBusy(true);
      try { await onChange(event.target.value); } finally { setBusy(false); }
    }}>
      {!options.some(option => option.value === value) && <option value={value}>{label}</option>}
      {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
    </Select>
  </div>;
}
